import { render, staticRenderFns } from "./approved-checkbox.vue?vue&type=template&id=327845d5&lang=pug"
import script from "./approved-checkbox.vue?vue&type=script&lang=js"
export * from "./approved-checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports